import React from 'react';

import { useTranslation } from 'react-i18next';

import {
  FOHButton,
  FOHColors,
  FOHView,
  FOHSpace,
  FOHSpaceLarger,
  FOHHeaderH2,
  FOHSmallDetailLabel,
  FOHReactiveModal
} from '../../../components';

import { WithReactiveModalProps } from '../../Navigation';

interface RemoveTeammateConfirmationModalProps extends WithReactiveModalProps {
  handleOnRemoveTeammate: () => void;
}

const RemoveTeammateConfirmationModal = (
  props: RemoveTeammateConfirmationModalProps
) => {
  const { t } = useTranslation('MyTeamFeature');

  return (
    <FOHReactiveModal open={props.open} close={props.close} dialog={true}>
      <FOHView
        style={{ alignItems: 'center' }}
        testID="FOHRemoveTeammateConfirmationModal"
      >
        <FOHHeaderH2>{t('removeTeammateConfirmationHeader')}</FOHHeaderH2>
        <FOHSpace />
        <FOHSmallDetailLabel
          style={{ paddingHorizontal: 4, textAlign: 'center' }}
        >
          {t('removeTeammateConfirmationDescription')}
        </FOHSmallDetailLabel>
        <FOHSpaceLarger />
        <FOHView
          style={{
            alignItems: 'center',
            flexDirection: 'row',
            paddingHorizontal: 4
          }}
        >
          <FOHButton
            borderColor={FOHColors.BORDER_GRAY}
            color={FOHColors.WHITE}
            onPress={() => props.close && props.close()}
            style={{ width: 128 }}
            textColor={FOHColors.BLACK}
            title={t('common:cancel')}
          />
          <FOHSpace />
          <FOHButton
            color={FOHColors.RED}
            onPress={props.handleOnRemoveTeammate}
            style={{ width: 128 }}
            title={t('remove')}
          />
        </FOHView>
      </FOHView>
    </FOHReactiveModal>
  );
};

export default RemoveTeammateConfirmationModal;
